export function headerInit() {
	document.addEventListener( 'DOMContentLoaded', function() {
		const submenuButton = document.querySelectorAll( '.open-submenu' );
		const menuItems = document.querySelectorAll( 'li.menu-item-has-children' );
		let timer;
		const mqLarge = window.matchMedia( '(min-width: 992px)' );
		const allMenuItems = document.querySelectorAll( '.menu-item' );

		// Toggle logic for button submenu buttons.
		if ( submenuButton ) {
			submenuButton.forEach( ( el ) => {
				const wrapper = el.closest( '.menu-item-wrapper' );
				wrapper.addEventListener( 'click', ( event ) => {
					event.preventDefault();

					const subMenu = el.closest( '.menu-item-has-children' );
					subMenu.classList.toggle( 'open' );

					const currentActiveMenuItemParent = el.closest( 'li' );
					allMenuItems.forEach( ( item ) => {
						// Close all other dropdown menus if menu is not active menu item.
						if (
							item.classList.contains( 'menu-item-has-children' ) &&
              item !== currentActiveMenuItemParent
						) {
							item.classList.remove( 'open' );
							item
								.querySelector( '.open-submenu' )
								.setAttribute( 'aria-expanded', 'false' );
						}
					} );

					// Change aria-expanded based which dropdown menu is open.
					if ( subMenu.classList.contains( 'open' ) ) {
						subMenu
							.querySelector( '.open-submenu' )
							.setAttribute( 'aria-expanded', 'true' );
					} else {
						subMenu
							.querySelector( '.open-submenu' )
							.setAttribute( 'aria-expanded', 'false' );
					}
				} );
			} );
		}

		// Header open logic.

		const siteNav = document.getElementById( 'site-navigation' );
		const mobileNavOpen = document.getElementById( 'mobile-nav-open' );
		const mobileNavClose = document.getElementById( 'mobile-nav-close' );

		// Focus trap to mobile navigation.
		// Get all focusable elements within the navigation (excluding the close button).
		const getFocusableElements = () => {
			const focusableSelectors = [
				'a[href]',
				'button:not([disabled]):not(#mobile-nav-close)',
				'input:not([disabled])',
				'select:not([disabled])',
				'textarea:not([disabled])',
				'[tabindex]:not([tabindex="-1"]):not(#mobile-nav-close)',
			];
			const allElements = siteNav.querySelectorAll( focusableSelectors.join( ',' ) );

			// Filter out elements that are not visible (like hidden language switcher items).
			return Array.from( allElements ).filter( ( element ) => {
				// Check if element or its parent is visible
				const style = window.getComputedStyle( element );
				const parentStyle = window.getComputedStyle( element.parentElement );

				const isVisible = style.display !== 'none' &&
					style.visibility !== 'hidden' &&
					parentStyle.display !== 'none' &&
					parentStyle.visibility !== 'hidden';

				// Special check for language switcher panel items.
				if ( element.closest( '#site-header-menu-lang__panel-mobile' ) ) {
					const panel = document.getElementById( 'site-header-menu-lang__panel-mobile' );
					return isVisible && panel && panel.classList.contains( 'visible' );
				}

				return isVisible;
			} );
		};

		// Focus trap handler.
		const handleFocusTrap = ( event ) => {
			// Only handle when navigation is active
			if ( ! siteNav.classList.contains( 'active' ) ) {
				return;
			}

			const focusableElements = getFocusableElements();
			const firstElement = focusableElements[ 0 ];
			const lastElement = focusableElements[ focusableElements.length - 1 ];
			const activeElement = siteNav.ownerDocument.activeElement;

			if ( event.key === 'Tab' ) {
				if ( event.shiftKey ) {
					// Shift + Tab (going backwards)
					if ( activeElement === firstElement ) {
						event.preventDefault();
						mobileNavClose.focus();
					} else if ( activeElement === mobileNavClose ) {
						event.preventDefault();
						lastElement.focus();
					}
				} else if ( activeElement === lastElement ) {
					// Tab (going forwards)
					event.preventDefault();
					mobileNavClose.focus();
				} else if ( activeElement === mobileNavClose ) {
					event.preventDefault();
					firstElement.focus();
				}
			}
		};

		const openMobileHeader = () => {
			siteNav.classList.add( 'active' );

			// Focus on first focusable element after a small delay to ensure the menu is open.
			setTimeout( () => {
				const focusableElements = getFocusableElements();
				if ( focusableElements.length > 0 ) {
					focusableElements[ 0 ].focus();
				}
			}, 100 );

			// Add focus trap listener to document to catch all Tab events.
			document.addEventListener( 'keydown', handleFocusTrap );
		};

		const closeMobileHeader = () => {
			siteNav.classList.remove( 'active' );

			// Remove focus trap listener from document.
			document.removeEventListener( 'keydown', handleFocusTrap );

			// Return focus to the open button.
			mobileNavOpen.focus();
		};

		mobileNavOpen.addEventListener( 'click', openMobileHeader );
		mobileNavClose.addEventListener( 'click', closeMobileHeader );

		document.addEventListener( 'keydown', ( event ) => {
			if ( event.key === 'Escape' && siteNav.classList.contains( 'active' ) ) {
				closeMobileHeader();
			}
		} );

		// Functions for menu hover actions.
		function openHoverMenu() {
			Array.prototype.forEach.call( menuItems, function( el ) {
				if ( el.classList.contains( 'open' ) ) {
					el.classList.remove( 'open' );
				}
			} );

			this.classList.add( 'open' );
			clearTimeout( timer );
		}

		function closeHoverMenu() {
			timer = setTimeout( function() {
				const openMenu = document.querySelector( '.menu-item-has-children.open' );
				if ( openMenu ) {
					openMenu.classList.remove( 'open' );
				}
			}, 500 );
		}

		// Handle mouseover actions and listening in desktop.
		function handleDesktopChange( e ) {
			// Run if breakpoint large or bigger.
			if ( e.matches ) {
				Array.prototype.forEach.call( menuItems, function( el ) {
					el.addEventListener( 'mouseover', openHoverMenu );
					el.addEventListener( 'mouseout', closeHoverMenu );
				} );
			} else {
				// On tablet and mobile, remove event listeners from menu items that have children.
				Array.prototype.forEach.call( menuItems, function( el ) {
					el.removeEventListener( 'mouseover', openHoverMenu );
					el.removeEventListener( 'mouseout', closeHoverMenu );
				} );
			}
		}

		// Register event listener to listen screen width changes.
		mqLarge.addListener( handleDesktopChange );

		// Initial check.
		handleDesktopChange( mqLarge );

		// Header scroll logic.
		let prevScroll = window.scrollY;
		const header = document.querySelector( 'header' );
		const top = header.offsetTop + 130;

		window.onscroll = () => {
			const currentScroll = window.scrollY;

			if ( currentScroll >= top ) {
				header.classList.add( 'static' );
			} else {
				header.classList.remove( 'static' );
			}

			if ( prevScroll >= currentScroll ) {
				header.style.top = '0';
			} else {
				header.style.top = '-300px';
			}

			prevScroll = currentScroll;
		};

		// Language switcher.
		const langToggle = document.querySelector( '#site-header-menu-lang__toggle' );
		const langToggleMobile = document.querySelector( '#site-header-menu-lang__toggle-mobile' );
		const langMenuPanel = document.querySelector( '#site-header-menu-lang__panel' );
		const langMenuPanelMobile = document.querySelector( '#site-header-menu-lang__panel-mobile' );

		// Only initialize language switcher if elements exist.
		if ( langToggle && langToggleMobile && langMenuPanel && langMenuPanelMobile ) {
			const toggleArrow = langToggle.lastElementChild;

			const toggleLanguageMenu = () => {
				if ( langToggle.hasAttribute( 'aria-controls' ) ) {
					langToggle.removeAttribute( 'aria-controls' );
				} else {
					langToggle.setAttribute(
						'aria-controls',
						'site-header-menu-lang__panel'
					);
				}

				toggleArrow.classList.toggle( 'reversed' );
				langMenuPanel.classList.toggle( 'visible' );

				if ( langMenuPanel.classList.contains( 'visible' ) ) {
					langToggle.setAttribute( 'aria-expanded', 'true' );
					langMenuPanel
						.querySelector( '.site-header-menu-lang__panel-list-item a' )
						.focus();
				} else {
					langToggle.setAttribute( 'aria-expanded', 'false' );
					langToggle.focus();
				}
			};
			const toggleLanguageMenuMobile = () => {
				if ( langToggleMobile.hasAttribute( 'aria-controls' ) ) {
					langToggleMobile.removeAttribute( 'aria-controls' );
				} else {
					langToggleMobile.setAttribute(
						'aria-controls',
						'site-header-menu-lang__panel'
					);
				}

				toggleArrow.classList.toggle( 'reversed' );
				langMenuPanelMobile.classList.toggle( 'visible' );

				if ( langMenuPanelMobile.classList.contains( 'visible' ) ) {
					langToggleMobile.setAttribute( 'aria-expanded', 'true' );
					langMenuPanelMobile
						.querySelector( '.site-header-menu-lang__panel-list-item a' )
						.focus();
				} else {
					langToggleMobile.setAttribute( 'aria-expanded', 'false' );
					langToggleMobile.focus();
				}
			};

			// Event listener for click and keyboard.
			langToggle.addEventListener( 'click', toggleLanguageMenu );

			// Event listener for click and keyboard.
			langToggleMobile.addEventListener( 'click', toggleLanguageMenuMobile );

			// Close the language menu with Escape key.
			document.addEventListener( 'keydown', ( event ) => {
				if (
					event.key === 'Escape' &&
					langMenuPanel.classList.contains( 'visible' )
				) {
					toggleLanguageMenu();
					langToggle.focus();
				}
			} );

			// Event listener for click and keyboard mobile.
			langToggleMobile.addEventListener( 'click', toggleLanguageMenu );

			// Close the language menu with Escape key.
			document.addEventListener( 'keydown', ( event ) => {
				if (
					event.key === 'Escape' &&
					langMenuPanel.classList.contains( 'visible' )
				) {
					toggleLanguageMenu();
					langToggleMobile.focus();
				}
			} );
		}

		// Notice that site has two different search forms one in mobilemenu and one in header.
		const search = document.getElementsByClassName( 'search-form-container' )[ 0 ];
		const searchLabel = document.getElementsByClassName( 'site-header-menu-search-icon' )[ 0 ];
		const searchDesktop = document.getElementsByClassName( 'site-header-menu-search-icon' )[ 1 ];
		const searchInput = document.getElementsByClassName( 'search-form--input' )[ 0 ];
		const searchSubmit = document.getElementsByClassName( 'search-form--submit' )[ 0 ];
		const searchClose = document.getElementsByClassName( 'search-form--close' )[ 0 ];

		const openSearch = () => {
			search.classList.add( 'search__open' );
			search.setAttribute( 'aria-expanded', 'true' );
			searchInput.focus();
		};

		const closeSearch = () => {
			search.classList.remove( 'search__open' );
			// searchLabel.style.display = "flex";
			search.setAttribute( 'aria-expanded', 'false' );
		};

		document.addEventListener( 'keydown', ( event ) => {
			if ( event.key === 'Escape' && search.classList.contains( 'search__open' ) ) {
				closeSearch();
				searchDesktop.focus();
			}
		} );

		searchDesktop.onclick = function( e ) {
			e.preventDefault();
			if ( search.classList.contains( 'search__open' ) ) {
				searchSubmit.click();
			} else {
				openSearch();
			}

			e.stopPropagation();
		};
		//Mobilemenu search
		searchLabel.onclick = function( e ) {
			e.preventDefault();
			if ( search.classList.contains( 'search__open' ) ) {
				searchSubmit.click();
			} else {
				openSearch();
			}

			e.stopPropagation();
		};
		searchInput.onclick = function( e ) {
			openSearch();
			e.stopPropagation();
		};

		searchClose.onclick = function() {
			closeSearch();
		};

		const serviceMenu = document.getElementsByClassName( 'site-header-menu-service' )[ 0 ];
		const serviceMenuOpen = document.getElementById( 'service-nav-open' );
		const serviceMenuClose = document.getElementById( 'service-nav-close' );

		const openServiceMenu = () => {
			serviceMenu.classList.add( 'service__open' );
			serviceMenu.setAttribute( 'aria-expanded', 'true' );
		};

		const closeServiceMenu = () => {
			serviceMenu.classList.remove( 'service__open' );
			serviceMenu.setAttribute( 'aria-expanded', 'false' );
		};

		serviceMenuOpen.onclick = function( e ) {
			e.preventDefault();
			openServiceMenu();
			e.stopPropagation();
		};
		serviceMenuClose.onclick = function() {
			closeServiceMenu();
		};

		document.addEventListener( 'keydown', ( event ) => {
			if ( event.key === 'Escape' && serviceMenu.classList.contains( 'service__open' ) ) {
				closeServiceMenu();
				serviceMenuOpen.focus();
			}
		} );
	} );
}
